  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //[POPOVER]
  import Popover                                             from '@material-ui/core/Popover';
  import IconButton                                          from '@material-ui/core/IconButton';
  import InputAdornment                                      from '@material-ui/core/InputAdornment';
  import Typography                                          from '@material-ui/core/Typography';
  import InfoIcon                                            from '@material-ui/icons/Info';
  //[PASSWORDTYPE]
//import InputAdornment                                      from '@material-ui/core/InputAdornment';
//import IconButton                                          from '@material-ui/core/IconButton';
  import Visibility                                          from '@material-ui/icons/Visibility';
  import VisibilityOff                                       from '@material-ui/icons/VisibilityOff';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_ProfileService }                               from "../../_services";
  //------
  // Style
  //------
  import SettingsChangePassStyle                             from "./SettingsChangePassStyle.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  import KeyboardBackspaceIcon                               from '@material-ui/icons/KeyboardBackspace'; //[goBack]
  //----------
  // variables
  //----------
  const filename = "SettingsChangePass ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  //[Lockers]
  var SettingsChangePass_continue_locked = true;

class SettingsChangePass extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      textField1                                           : "",
      textField1_hasError                                  : false,
      textField2                                           : "",
      textField2_hasError                                  : false,
      textField3                                           : "",
      textField3_hasError                                  : false,

      passwordType1                                        : "password",
      passwordType2                                        : "password",
      passwordType3                                        : "password",

      //popup success
      dialog_success_msg                                   : "",
      dialog_success_isOpen                                : false,

      //popup sessionTimeout
      dialog_sessionTimeout_msg                            : "",
      dialog_sessionTimeout_isOpen                         : false,

      //[POPOVER]
    //password1_popover_isOpen                             : false,
      password2_popover_isOpen                             : false,
      password3_popover_isOpen                             : false,
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                           = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                          = this.dialog_handleClose.bind(this);
    this.startSpinners                                               = this.startSpinners.bind(this);
    this.stopSpinners                                                = this.stopSpinners.bind(this);

    //[Lockers]
    this.isLockersActive                                             = this.isLockersActive.bind(this);
    this.startLockers                                                = this.startLockers.bind(this);
    this.stopLockers                                                 = this.stopLockers.bind(this);

    //[goBack]
    this.goBack                                                      = this.goBack.bind(this);

    //[SNACKBAR]
    this.Snackbar_textField_handleOpen                               = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                              = this.Snackbar_textField_handleClose.bind(this);

    this.get_PasswordType1                                           = this.get_PasswordType1.bind(this);
    this.handlePopoverOpen_passwordType1                             = this.handlePopoverOpen_passwordType1.bind(this);
    this.get_PasswordType2                                           = this.get_PasswordType2.bind(this);
    this.handlePopoverOpen_passwordType2                             = this.handlePopoverOpen_passwordType2.bind(this);
    this.get_PasswordType3                                           = this.get_PasswordType3.bind(this);
    this.handlePopoverOpen_passwordType3                             = this.handlePopoverOpen_passwordType3.bind(this);

    //[POPOVER]
  //this.handlePopoverOpen_password1                                 = this.handlePopoverOpen_password1.bind(this);
  //this.handlePopoverClose_password1                                = this.handlePopoverClose_password1.bind(this);
    this.handlePopoverOpen_password2                                 = this.handlePopoverOpen_password2.bind(this);
    this.handlePopoverClose_password2                                = this.handlePopoverClose_password2.bind(this);
    this.handlePopoverOpen_password3                                 = this.handlePopoverOpen_password3.bind(this);
    this.handlePopoverClose_password3                                = this.handlePopoverClose_password3.bind(this);

    //popup success
    this.dialog_success_handleOpen                                   = this.dialog_success_handleOpen.bind(this);
    this.dialog_success_btn_add                                      = this.dialog_success_btn_add.bind(this);

    //popup sessionTimeout
    this.dialog_sessionTimeout_handleOpen                            = this.dialog_sessionTimeout_handleOpen.bind(this);
    this.dialog_sessionTimeout_btn_ok                                = this.dialog_sessionTimeout_btn_ok.bind(this);

    this.btn_save_act                                                = this.btn_save_act.bind(this);
    this.btn_save_act_isDisabled                                     = this.btn_save_act_isDisabled.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);
    if(api.print_logs){console.log(methName+localStorage.getItem("prev_view"));}
    if(api.print_logs){console.log(methName+localStorage.getItem("curr_view")+",history.length="+history.length);}

    //[Lockers]
    this.stopLockers();

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    if(!wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return;
    }
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>

            {api.backButtonAtHeader === true ? (
              <GridContainer justify="center">
                <GridItem xs={2} sm={2} md={1}>
                  <div style={{ marginTop:20,marginBottom:10, textAlign:"left" }}>
                    {/* ----------[goBack]------------ */}
                    <Button style={{ backgroundColor:"#FFDD00" }} onClick={this.goBack}><KeyboardBackspaceIcon/></Button>
                  </div>
                </GridItem>
                <GridItem xs={10} sm={10} md={11}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("ChangePassword_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            ) : (
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("ChangePassword_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            )}

            {/* ------------------------- */}
            {/* ----------ROW------------ */}
            {/* ------------------------- */}
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <TextField
                  fullWidth
                  error={this.state.textField1_hasError}
                  className={classes.textField1}
                  id="textField1"
                  label={this.NSInforString("ChangePassword_plh1")}
                  defaultValue={this.state.textField1}
                  value={this.state.textField1}
                  InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField1"), type: this.get_PasswordType1(),
                  endAdornment:
                    <InputAdornment position="end">
                      <IconButton onClick={this.handlePopoverOpen_passwordType1}  style={{padding:0}}> {this.get_PasswordType1()==="text" ? <VisibilityOff /> : <Visibility />}</IconButton>
                    </InputAdornment>
                  // endAdornment:
                  //   <InputAdornment position="end">
                  //     <IconButton onClick={this.handlePopoverOpen_password1} onMouseDown={this.handlePopoverOpen_password1} style={{padding:0}}><InfoIcon/></IconButton>
                  //   </InputAdornment>
                  }}
                />
                {/* ------------------------- */}
                {/* ----------[POPOVER]------ */}
                {/* ------------------------- */}
                {/* <Popover
                  id="password1_popover"
                  className={classes.popover}
                  classes={{ paper:classes.paper }}
                  open={this.state.password1_popover_isOpen}
                  anchorEl={document.getElementById("textField1")}
                  anchorOrigin={{ vertical:'bottom', horizontal:'left' }}
                  transformOrigin={{ vertical:'top', horizontal:'left' }}
                  onClose={this.handlePopoverClose_password1}
                  disableRestoreFocus
                >
                  <Typography style={{width:280, padding:5}}>{this.NSInforString("popover_generic_password")}</Typography>
                </Popover> */}
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <TextField
                  fullWidth
                  error={this.state.textField2_hasError}
                  className={classes.textField2}
                  id="textField2"
                  label={this.NSInforString("ChangePassword_plh2")}
                  defaultValue={this.state.textField2}
                  value={this.state.textField2}
                  InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField2"), type: this.get_PasswordType2(),
                  endAdornment:
                    <InputAdornment position="end">
                      <IconButton onClick={this.handlePopoverOpen_password2} onMouseDown={this.handlePopoverOpen_password2} style={{padding:0}}><InfoIcon/></IconButton>
                      <IconButton onClick={this.handlePopoverOpen_passwordType2}  style={{padding:0}}> {this.get_PasswordType2()==="text" ? <VisibilityOff /> : <Visibility />}</IconButton>
                    </InputAdornment>
                  }}
                />
                {/* ------------------------- */}
                {/* ----------[POPOVER]------ */}
                {/* ------------------------- */}
                <Popover
                  id="password2_popover"
                  className={classes.popover}
                  classes={{ paper:classes.paper }}
                  open={this.state.password2_popover_isOpen}
                  anchorEl={document.getElementById("textField2")}
                  anchorOrigin={{ vertical:'bottom', horizontal:'left' }}
                  transformOrigin={{ vertical:'top', horizontal:'left' }}
                  onClose={this.handlePopoverClose_password2}
                  disableRestoreFocus
                >
                  <Typography style={{width:280, padding:5}}>{this.NSInforString("popover_generic_password")}</Typography>
                </Popover>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <TextField
                  fullWidth
                  error={this.state.textField3_hasError}
                  className={classes.textField3}
                  id="textField3"
                  label={this.NSInforString("ChangePassword_plh3")}
                  defaultValue={this.state.textField3}
                  value={this.state.textField3}
                  InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField3"), type: this.get_PasswordType3(),
                  endAdornment:
                    <InputAdornment position="end">
                      <IconButton onClick={this.handlePopoverOpen_password3} onMouseDown={this.handlePopoverOpen_password3} style={{padding:0}}><InfoIcon/></IconButton>
                      <IconButton onClick={this.handlePopoverOpen_passwordType3}  style={{padding:0}}> {this.get_PasswordType3()==="text" ? <VisibilityOff /> : <Visibility />}</IconButton>
                    </InputAdornment>
                  }}
                />
                {/* ------------------------- */}
                {/* ----------[POPOVER]------ */}
                {/* ------------------------- */}
                <Popover
                  id="password3_popover"
                  className={classes.popover}
                  classes={{ paper:classes.paper }}
                  open={this.state.password3_popover_isOpen}
                  anchorEl={document.getElementById("textField3")}
                  anchorOrigin={{ vertical:'bottom', horizontal:'left' }}
                  transformOrigin={{ vertical:'top', horizontal:'left' }}
                  onClose={this.handlePopoverClose_password3}
                  disableRestoreFocus
                >
                  <Typography style={{width:280, padding:5}}>{this.NSInforString("popover_generic_password")}</Typography>
                </Popover>
              </GridItem>
            </GridContainer>
            {/* ------------------------- */}
            {/* ----------[SPINNERS]----- */}
            {/* ------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}
            {/* ------------------------- */}
            {/* ----------[BUTTONS]------ */}
            {/* ------------------------- */}
            <GridContainer justify="center">
              <GridItem xs={10} sm={10} md={10}>
                <div className={classes.textCenter}>
                  <CustomButton
                    disabled={this.btn_save_act_isDisabled()}
                    className={classes.yellowButton}
                    color="rose"
                    onClick={this.btn_save_act}
                    type="submit">
                    {this.NSInforString("ChangePassword_btn_save")}
                  </CustomButton>
                </div>
              </GridItem>
            </GridContainer>
            {/* -------------------------------------------------- */}
            {/* ----------[goBack Bottom]------------------------- */}
            {/* -------------------------------------------------- */}
            {api.backButtonAtBottom === true ? (
              <GridContainer justify="center">
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    <CustomButton
                      disabled={false}
                      className={classes.backButton}
                      color="rose"
                      onClick={this.goBack}>
                      {this.NSInforString("ChangePassword_btn_prev")}
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
            ) : ( "" ) }

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={api.snackBarDurationMS} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------------------- */}
        {/* ----------[POPUP success]--------------- */}
        {/* ---------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_success_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_success_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <GridItem xs={12} sm={12} md={12}><div className={classes.viewRN_key}>{this.state.dialog_success_msg}</div></GridItem>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton_success} color="default" onClick={this.dialog_success_btn_add}>{this.NSInforString("alert_OK")}</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------------------- */}
        {/* ----------[POPUP sessionTimeout]-------- */}
        {/* ---------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_sessionTimeout_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_sessionTimeout_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <GridItem xs={12} sm={12} md={12}><div className={classes.viewRN_key}>{this.state.dialog_sessionTimeout_msg}</div></GridItem>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton_success} color="default" onClick={this.dialog_sessionTimeout_btn_ok}>{this.NSInforString("alert_OK")}</Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //https://material-ui.com/components/lists/
  // function generate(element) {
  //   return [0, 1, 2].map(value =>
  //     React.cloneElement(element, {
  //       key: value,
  //     }),
  //   );
  // }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_save_act_isDisabled(){
    if(this.isLockersActive()===true){ return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_save_act(event) {
    let methName = filename+"btn_save_act ";
    if(api.print_logs){console.log(methName);}

    //[Lockers]
    if( this.isLockersActive() ){ return; }
    else                        { this.startLockers(); }

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.textField1.trim() === "") { this.setState({"textField1_hasError" : true }); emptyFields = true; }
      if(this.state.textField2.trim() === "") { this.setState({"textField2_hasError" : true }); emptyFields = true; }
      if(this.state.textField3.trim() === "") { this.setState({"textField3_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){this.stopLockers(); return;}
    }



    //-------------------------
    //validate Current Password
    //-------------------------
    let textField1text = this.state.textField1.trim();
    if(textField1text === ""){
      this.setState({"textField1_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+" "+this.NSInforString("ChangePassword_plh1"));
      //if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    let textField1text_hasGreekChar = false;
    for(let i=0; textField1text.length>0 && i<textField1text.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(textField1text[i])===true){ textField1text_hasGreekChar=true; break; } }
    if(textField1text_hasGreekChar===true){
      this.setState({"textField1_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("common.field.latin_no_greek"));
      //if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    //---------------------
    //validate New Password
    //---------------------
    let textField2text = this.state.textField2.trim();
    if(textField2text === ""){
      this.setState({"textField2_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+" "+this.NSInforString("ChangePassword_plh2"));
      //if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    let textField2text_hasGreekChar = false;
    for(let i=0; textField2text.length>0 && i<textField2text.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(textField2text[i])===true){ textField2text_hasGreekChar=true; break; } }
    if(textField2text_hasGreekChar===true){
      this.setState({"textField2_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("common.field.latin_no_greek"));
      //if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    //-------------------------
    //validate Confirm Password
    //-------------------------
    let textField3text = this.state.textField3.trim();
    if(textField3text === ""){
      this.setState({"textField3_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+" "+this.NSInforString("ChangePassword_plh3"));
      //if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    let textField3text_hasGreekChar = false;
    for(let i=0; textField3text.length>0 && i<textField3text.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(textField3text[i])===true){ textField3text_hasGreekChar=true; break; } }
    if(textField3text_hasGreekChar===true){
      this.setState({"textField3_hasError" : true });
      this.dialog_handleOpen(this.NSInforString("common.field.latin_no_greek"));
      //if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    //-----------------------------------------------
    //validate Compare(New Password,Confirm Password)
    //-----------------------------------------------
    if( textField2text !==textField3text ){ this.dialog_handleOpen(this.NSInforString("passwords.do.not.match")); this.stopLockers(); return;}

    event.preventDefault();

    this.startSpinners();
    setTimeout(function() { //Start the timer
      //-----------------
      //wu_changePassword
      //-----------------
      wu_ProfileService
      .wu_changePassword({oldPassword:textField1text,newPassword:textField2text})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="SettingsChangePass"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        this.stopLockers();this.stopSpinners();
        if(res.returnCode===0){
          this.dialog_success_handleOpen(res.returnText);
        }
      })
      .catch(err => {
        this.stopLockers();this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){this.dialog_sessionTimeout_handleOpen(err.returnText);return;} this.dialog_handleOpen(err.returnText); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+eventTMP);}

    // if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
    //   this.setState({"textField0":eventTMP.trim(),});
    // }
    if(stateVar==="textField1"){
      this.setState({
        "textField1"          : eventTMP,
        "textField1_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      for(let i=0; eventTMP.length>0 && i<eventTMP.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(eventTMP[i])===true){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin_no_greek")); this.setState({"textField1_hasError":true}); return; } }
    }
    else if(stateVar==="textField2"){
      this.setState({
        "textField2"          : eventTMP,
        "textField2_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      for(let i=0; eventTMP.length>0 && i<eventTMP.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(eventTMP[i])===true){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin_no_greek")); this.setState({"textField2_hasError":true}); return; } }
    }
    else if(stateVar==="textField3"){
      this.setState({
        "textField3"          : eventTMP,
        "textField3_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      for(let i=0; eventTMP.length>0 && i<eventTMP.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(eventTMP[i])===true){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin_no_greek")); this.setState({"textField3_hasError":true}); return; } }
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="email"){ return wu_Utilities.wu_verifyEmail(val); }
    if(key==="MTCN") { return wu_Utilities.wu_verifyMTCN(val);  }

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {
    //history.go(-1);
    history.goBack();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg){
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups sessionTimeout-----------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_sessionTimeout_handleOpen(dialog_msg,dType){
    setTimeout(function() {
      this.setState({"dialog_sessionTimeout_isOpen":true,"dialog_sessionTimeout_msg":dialog_msg});
    }.bind(this), api.initialLoadGracePeriodMS);
    return;
  }
  //----------------------------------------------------------------------------------------------------
  dialog_sessionTimeout_btn_ok(){
    let methName = filename+"dialog_sessionTimeout_btn_ok ";
    if(api.print_logs){console.log(methName);}

    wu_Utilities.LogoutUserFromApp(filename);
    history.push(wu_Utilities.getNavigationURLs("LoginPage"));
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups success------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_success_handleOpen(dialog_msg,dType){
    setTimeout(function() {
      this.setState({
        "dialog_success_isOpen" : true,
        "dialog_success_msg"    : dialog_msg
      });
    }.bind(this), api.initialLoadGracePeriodMS);
    return;
  }
  //----------------------------------------------------------------------------------------------------
  dialog_success_btn_add(){
    let methName = filename+"dialog_success_btn_add ";
    if(api.print_logs){console.log(methName);}

    let parserObject_validatecustomer = {};
    try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
    let prefill_userName_after_changePass = parserObject_validatecustomer.email;
    localStorage.setItem("prefill_userName_after_changePass", prefill_userName_after_changePass);
    if(api.print_logs){console.log(methName+"prefill_userName_after_changePass="+prefill_userName_after_changePass);}

    wu_Utilities.LogoutUserFromApp(filename);
    history.push(wu_Utilities.getNavigationURLs("LoginPage"));
    //history.goBack();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[POPOVER]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  // handlePopoverOpen_password1(){
  //   this.setState({ "password1_popover_isOpen" : true, });
  // }
  // handlePopoverClose_password1(){
  //   this.setState({ "password1_popover_isOpen" : false, });
  // }
  //----------------------------------------------------------------------------------------------------
  handlePopoverOpen_password2(){
    this.setState({ "password2_popover_isOpen" : true, });
  }
  handlePopoverClose_password2(){
    this.setState({ "password2_popover_isOpen" : false, });
  }
  //----------------------------------------------------------------------------------------------------
  handlePopoverOpen_password3(){
    this.setState({ "password3_popover_isOpen" : true, });
  }
  handlePopoverClose_password3(){
    this.setState({ "password3_popover_isOpen" : false, });
  }
  //----------------------------------------------------------------------------------------------------
  get_PasswordType1(){
    return this.state.passwordType1;
  }
  handlePopoverOpen_passwordType1(){
    if(this.state.passwordType1==="password"){this.setState({ "passwordType1" : "text", });}
    if(this.state.passwordType1==="text")    {this.setState({ "passwordType1" : "password", });}
  }
  get_PasswordType2(){
    return this.state.passwordType2;
  }
  handlePopoverOpen_passwordType2(){
    if(this.state.passwordType2==="password"){this.setState({ "passwordType2" : "text", });}
    if(this.state.passwordType2==="text")    {this.setState({ "passwordType2" : "password", });}
  }
  get_PasswordType3(){
    return this.state.passwordType3;
  }
  handlePopoverOpen_passwordType3(){
    if(this.state.passwordType3==="password"){this.setState({ "passwordType3" : "text", });}
    if(this.state.passwordType3==="text")    {this.setState({ "passwordType3" : "password", });}
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[Lockers]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  isLockersActive(){
    if( SettingsChangePass_continue_locked===true ){ return true;  }
    else                                           { return false; }
    //if( localStorage.getItem(filename.trim()+"_continue_locked")==="true" ){ /*console.log("isLockersActive===true");*/  return true;  }
    //else                                                                   { /*console.log("isLockersActive===false");*/ return false; }
  }
  //----------------------------------------------------------------------------------------------------
  startLockers(){
    SettingsChangePass_continue_locked = true;
    //localStorage.setItem(filename.trim()+"_continue_locked","true");
  }
  //----------------------------------------------------------------------------------------------------
  stopLockers(){
    SettingsChangePass_continue_locked = false;
    //localStorage.setItem(filename.trim()+"_continue_locked","false");
  }
  //----------------------------------------------------------------------------------------------------
}
SettingsChangePass.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(SettingsChangePassStyle)(SettingsChangePass)
);
